import { AcademicUnit, Campus, Package, Subject } from "@models/ISchema";
import { AdaptedGroup } from "../models";
import { BooleanFilterId, FiltersReducerType } from "./types";

/** Set all advanced filters to false and the main selectors to their empty values. */
export const cleanFilters = (state: FiltersReducerType): FiltersReducerType => ({
  ...state,
  campus: null,
  courseTypesById: {},
  department: null,
  school: null,
  selectedCrn: null,
  selectedPackage: null,
  subject: null,
  state: { active: false, inactive: false },
  visibility: { visible: false, invisible: false },
  availability: { available: false, unavailable: false },
  enrollments: { with: false, without: false },
});

export const setAdvancedFilter = (
  filter: BooleanFilterId,
  value: boolean,
  state: FiltersReducerType,
): FiltersReducerType => {
  switch (filter) {
    case "owned":
      return { ...state, owned: value };
    case "state.active":
      return { ...state, state: { ...state.state, active: value } };
    case "state.inactive":
      return { ...state, state: { ...state.state, inactive: value } };
    case "visibility.visible":
      return { ...state, visibility: { ...state.visibility, visible: value } };
    case "visibility.invisible":
      return { ...state, visibility: { ...state.visibility, invisible: value } };
    case "availability.available":
      return { ...state, availability: { ...state.availability, available: value } };
    case "availability.unavailable":
      return { ...state, availability: { ...state.availability, unavailable: value } };
    case "enrollments.with":
      return { ...state, enrollments: { ...state.enrollments, with: value } };
    case "enrollments.without":
      return { ...state, enrollments: { ...state.enrollments, without: value } };
  }
};

export const setCampus = (campus: Campus, state: FiltersReducerType): FiltersReducerType => ({
  ...state,
  campus,
});

export const setDepartment = (
  department: AcademicUnit,
  state: FiltersReducerType,
): FiltersReducerType => ({ ...state, department });

export const addCourseTypeById = (
  courseType: AcademicUnit,
  state: FiltersReducerType,
): FiltersReducerType => ({
  ...state,
  courseTypesById: {
    ...state.courseTypesById,
    [courseType?.id]: courseType,
  },
});

export const removeCourseTypeById = (
  courseType: AcademicUnit,
  state: FiltersReducerType,
): FiltersReducerType => ({
  ...state,
  courseTypesById: Object.fromEntries(
    Object.entries(state.courseTypesById).filter(([id]) => id !== String(courseType?.id)),
  ),
});

export const setSchool = (school: AcademicUnit, state: FiltersReducerType): FiltersReducerType => ({
  ...state,
  school,
});

export const setSubject = (subject: Subject, state: FiltersReducerType): FiltersReducerType => ({
  ...state,
  subject,
});

export const selectCrn = (crn: AdaptedGroup, state: FiltersReducerType): FiltersReducerType => ({
  ...state,
  selectedCrn: crn,
});

export const selectPackage = (packageId: Package["id"], state: FiltersReducerType) => ({
  ...state,
  selectedPackage: packageId,
});
